module.exports = __webpack_public_path__ + "img/advantage1.02324f1b.png";